import React from 'react';
import { Typography, LinearProgress } from '@material-ui/core';

import { useStyles } from './styles';

interface IUnitChart {
  title: string;
  value: number;
  variant?: 'dark' | 'light';
}

const UnitChart: React.FC<IUnitChart> = ({ title, value, variant }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="subtitle1" className={classes.title}>
        {title}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={100}
        className={
          variant === 'light'
            ? classes.progressVariantLight
            : classes.progressVariantDark
        }
        style={{
          width: value,
        }}
      />
    </div>
  );
};

export default UnitChart;
